import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: var(--white);
  padding: 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid var(--gray);
    border-radius: 5%;
    background: var(--white);
    padding: 35px 80px;

    @media (max-width: 320px) {
      padding: 0px 80px;
    }

    h2 {
      color: var(--blueDark);
      padding: 20px 0;
      display: flex;
      align-self: flex-start;
    }

    > div {
      font-size: 0.9rem;
      font-weight: bold;
      display: flex;
      align-self: flex-start;
    }

    div.inputClass {
      display: flex;
      flex-direction: column;
      width: 100%;

      #imageInput {
        align-self: flex-end;
        position: relative;
        top: calc(-53px);
        left: calc(-3%);
      }
      #imageInput2 {
        align-self: flex-end;
        position: relative;
        top: calc(-53px);
        left: calc(-3%);
      }
      #imageInput3 {
        align-self: flex-end;
        position: relative;
        top: calc(-53px);
        left: calc(-3%);
      }
    }

    input {
      display: flex;
      width: 100%;
      border: 1px solid var(--gray);
      border-radius: 10px;
      height: 50px;
      padding: 0px 35px 0px 15px;
      margin: 10px 0 10px 0;
      color: var(--black);
      display: ${props => props.visible};

      &::placeholder {
        color: var(--gray);
      }
    }

    span {
      color: var(--salmon);
      align-self: center;
      margin: 0 0 10px;
      font-weight: bold;
      font-size: 14px;
    }

    svg {
      height: 35px;
      cursor: pointer;
      color: var(--blueDark);
    }

    button {
      margin: 20px 0 0;
      height: 30px;
      background: var(--yellowDark);
      width: 40%;
      color: var(--blueDark);
      border: 0;
      border-radius: 10px;
      font-size: 14px;
      font-weight: bold;
      transition: background 0.2s;
      box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.75);

      &:hover {
        background: ${darken(0.06, '#f7c325')};
      }
    }
  }
`;

export const ContainerSuccess = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: var(--white);
  padding: 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid var(--gray);
    border-radius: 5%;
    background: var(--white);
    padding: 35px 50px;
    margin-bottom: 15%;

    h2 {
      color: var(--blueDark);
      padding: 10px 0 40px;
      display: flex;
      align-self: flex-start;
    }

    > div {
      font-size: 15px;
      font-weight: bold;
      display: flex;
      align-self: flex-start;
    }
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;
